import {
  useCallback, useEffect, useMemo, useState,
} from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import FieldV2 from 'src/components/FormComponents/FieldV2'
import Submit from 'src/components/FormComponents/Submit'
import Modal from 'src/components/Modal'
import TaxCouponApi from 'src/features/tax-coupon/TaxCouponApi'
import { selectShouldOpenSearchModal } from 'src/features/tax-coupon/TaxCouponSelectors'
import { actions } from 'src/features/tax-coupon/TaxCouponState'
import * as S from './TaxCouponSearchModal.styles'

interface Product {
  idModelo: string,
  descProduto: string,
  scannedIdMeasure: number
}

export default () => {
  const dispatch = useDispatch()
  const shouldOpenSearchModal = useSelector(selectShouldOpenSearchModal)

  const title = 'Buscar produto por descrição'

  const { getValues, setValue, control } = useForm<{ term: string }>()

  const [suggestions, setSuggestions] = useState([])
  const [selected, setSelected] = useState<Product>()

  let timeout: ReturnType<typeof setTimeout>

  const isProductNotSelected = useMemo(() => !selected, [selected])

  const searchTerm = (term: string) => TaxCouponApi.getProductsByDescription(term)

  const handleInput = () => {
    clearTimeout(timeout)

    timeout = setTimeout(async () => {
      const term = getValues('term')
      const { data: loadedSuggestions } = await searchTerm(term)
      setSuggestions(loadedSuggestions)
    }, 1000)
  }

  const selectProduct = (product) => {
    setSuggestions([])
    setSelected(product)
  }

  const clearModal = useCallback(() => {
    setSuggestions([])
    setSelected(undefined)
    setValue('term', '')
  }, [setValue])

  const handleFinishClick = () => {
    if (!selected) return
    const { idModelo, descProduto } = selected
    dispatch(actions.setBarcodeData({ idModelo: Number(idModelo), description: descProduto }))
    dispatch(actions.shouldOpenSearchModal(false))
    clearModal()
  }

  useEffect(() => {
    clearModal()
  }, [shouldOpenSearchModal, clearModal])

  const renderSuggestions = () => (
    <S.SuggestionContainer>
      {
        suggestions.map(({ idModelo, descProduto }) => (
          <S.Suggestion key={idModelo} onClick={() => selectProduct({ idModelo, descProduto })}>
            {descProduto}
          </S.Suggestion>
        ))
      }
    </S.SuggestionContainer>
  )

  const modalBody = (
    <S.Body id='search-product'>
      <S.Text>Digite a descrição do produto que deseja encontrar</S.Text>

      <S.Field
        as={FieldV2}
        control={control}
        labelText='Buscar'
        name='term'
        onInput={handleInput}
      />

      {renderSuggestions()}

      <S.Selected>
        <S.Text>Produto selecionado: <strong>{selected?.descProduto}</strong></S.Text>
      </S.Selected>

      <S.FinishSearch
        as={Submit}
        disabled={isProductNotSelected}
        onClick={() => handleFinishClick()}
        text='Finalizar escolha de produto'
      />
    </S.Body>
  )

  return (
    <Modal
      show={shouldOpenSearchModal}
      centered
      title={title}
      closedButton={false}
      body={modalBody}
      onHide={() => { dispatch(actions.shouldOpenSearchModal(false)) }}
    />
  )
}
